import React, { Dispatch, SetStateAction } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TableRow, TableCell, Checkbox } from '@material-ui/core';
import {
  JudgeInfo,
  PlcInfo,
  V_RT_TREND_SETTING_ITEM,
  KIND_NO_NAME_SET,
  ColSetInfo,
} from '../../../../function/GroupDataModel';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ColorPicker from '../ColorPicker';
import NumericEntry from '../../../atoms/Input/NumericEntry';
import { GetLimit, GetUnit, CLC_TYP_SET } from '../TrendSetting/TrendSetting';
import NumericEntry_inputEx from '../../../atoms/Input/NumericEntry_inputEx';
import RealTimeTrendGraphButtonList from '../../RealTimeTrendGraph/RealTimeTrendGraphButtonList';
import { JudgeSettingSelectType, GetJudgeSettingSelectItems } from '../../../../function/JudgeSettingSelectModel';
import { TableBaseStyle, RealtimeSettingStyle } from './RealtimeSettingStyle';
import { MeasureHighKind, AlmTypKind, SpeedKind } from '../../../../Constant';
import { MST_CLC_TYPE } from '../../MeasureSetting/JudgeSetting/JudgeSetting';
import { ALM_KIND_SET } from '../../../../function/AlmKindSetModel';
import { IsConanAirPlc } from '../../../../function/PlcNoModel';

type RealtimeSettingItemProps = {
  rowno: number;
  selectIdx: number;
  setSelectIdx: Dispatch<SetStateAction<number>>;
  item: V_RT_TREND_SETTING_ITEM;
  updateItem: (item: V_RT_TREND_SETTING_ITEM) => void;
  measKinds: ComboBoxItemType[];
  deviceLists: ComboBoxItemType[];
  itemLists: ComboBoxItemType[];
  dataKinds: ComboBoxItemType[];
  alarmKinds: ComboBoxItemType[];
  alarmLimits: JudgeInfo[];
  // deviceUnitInfos: PlcInfo[];
  colSetInfos: ColSetInfo[];
  kindNoNameSets: KIND_NO_NAME_SET[];
  judgeSetSelect: JudgeSettingSelectType[];
  mClcTypes: ComboBoxItemType[];
};

const getKindIndex = (item: V_RT_TREND_SETTING_ITEM, nameSets: KIND_NO_NAME_SET[]): number => {
  var index = nameSets.findIndex((r) => r.SPEED == item.SPEED && r.NAME_NO == item.KIND_NO);
  //console.debug(['item,nameSets,index', item, nameSets, index]);
  return index;
};

const RealtimeSettingItem: React.FC<RealtimeSettingItemProps> = (props: RealtimeSettingItemProps) => {
  const tableStyle = TableBaseStyle();
  const pageStyle = RealtimeSettingStyle();

  const unit = GetUnit(
    props.colSetInfos,
    props.item.PLC_NO,
    props.item.AI_CARD,
    props.item.AI_CH,
    props.item.CLC,
    props.item.KIND_NO
  );

  /**
   * 計測種別アイテム種痘
   * @returns
   */
  const measFilterCombos = (): ComboBoxItemType[] => {
    //console.debug(['計測種別アイテム取得', props.judgeSetSelect, props.measKinds]);
    return props.measKinds;
    // return props.measKinds.filter((r) => {
    //   let v = r.tag as KIND_NO_NAME_SET;
    //   if (r.index === 0 || v == null) {
    //     return true;
    //   }
    //   if (props.judgeSetSelect.findIndex((row) => row.SPEED === v.SPEED && row.NAME_NO === v.NAME_NO) !== -1) {
    //     return true;
    //   }
    //   return false;
    // });
  };

  /**
   * 項目種別アイテム種痘
   * @returns
   */
  const itemListFilterCombos = (): ComboBoxItemType[] => {
    let findCols = props.colSetInfos.filter(
      (csi) =>
        IsConanAirPlc(String(csi.PLC_NO)) === false &&
        csi.DEV_INDEX === props.item.DEV_INDEX &&
        csi.SPEED === props.item.SPEED &&
        csi.KIND_NO === props.item.KIND_NO
    );
    let findCols2 = props.colSetInfos.filter(
      (csi) =>
        IsConanAirPlc(String(csi.PLC_NO)) === true &&
        csi.DEV_INDEX === props.item.DEV_INDEX &&
        csi.SPEED === props.item.SPEED
    );

    findCols = findCols.concat(findCols2);

    return props.itemLists.filter((r) => {
      if (r.index === 0) {
        return true;
      }
      if (findCols.findIndex((row) => row.ITM_NAME_NO === r.index) !== -1) {
        return true;
      }
      return false;
    });
  };
  /**
   *データ種別
   * @returns
   */
  const createDataKindCombos = (): ComboBoxItemType[] => {
    //console.debug(['データ種別選択候補リスト情報', props.item, props.dataKinds]);

    if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD || props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP) {
      //console.debug('VIBRATION_SPD');
      if (props.item.CLC !== 4) {
        props.item.CLC = 4;
        props.updateItem(props.item);
      }
      return props.dataKinds.filter((r) => r.index === 4);
    }

    return props.dataKinds.filter((r) => {
      let v = r.tag as CLC_TYP_SET;
      let item = props.item;

      if (r.index === 0 || v == null) {
        return true;
      }
      if (
        props.judgeSetSelect.findIndex(
          (row) => row.SPEED === item.SPEED && row.NAME_NO === item.KIND_NO && row.TYP_NO_CLC === v.TYP_NO
        ) !== -1
      ) {
        return true;
      }
      return false;
    });
  };

  /**
   *演算種別
   * @returns
   */
  const createMclcCombos = (): ComboBoxItemType[] => {
    //console.debug(['演算種別選択候補リスト情報', props.item, props.mClcTypes, props.judgeSetSelect]);
    if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD || props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP) {
      return props.mClcTypes.filter((r) => {
        let v = r.tag as MST_CLC_TYPE;
        if (r.index === 0 || v == null) {
          return true;
        }

        if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD && r.index === AlmTypKind.eRawSpd) {
          return true;
        }
        if (props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP && r.index === AlmTypKind.eRawDsp) {
          return true;
        }
        return false;
      });
    } else {
      return props.mClcTypes.filter((r) => {
        let v = r.tag as MST_CLC_TYPE;
        let item = props.item;

        if (r.index === 0 || v == null) {
          return true;
        }
        if (
          props.judgeSetSelect.findIndex(
            (row) =>
              row.SPEED === item.SPEED &&
              row.NAME_NO === item.KIND_NO &&
              row.TYP_NO_CLC === item.CLC &&
              row.MCLC_TYP_ID === v.MCLC_TYP_ID
          ) !== -1
        ) {
          return true;
        }
        return false;
      });
    }
  };
  /**
   *異常種別
   * @returns
   */
  const createAlarmKindCombos = (): ComboBoxItemType[] => {
    //console.debug(['異常種別候補リスト', props.item, props.alarmKinds]);
    return props.alarmKinds.filter((r) => {
      let v = r.tag as ALM_KIND_SET;
      let item = props.item;
      //console.debug(['異常種別候補リスト2', props.item, props.alarmKinds, v]);
      if (r.index === 0 || v == null) {
        return true;
      }
      if (v.MCLC_TYP_ID === item.MCLC_TYP_ID) {
        return true;
      }
      return false;
    });
  };

  const selectRow = () => {
    props.setSelectIdx(props.rowno);
  };

  return (
    <TableRow className={props.rowno === props.selectIdx ? pageStyle.activeRow : ''}>
      {/* 表示 有*/}
      <TableCell className={tableStyle.bodyCell} width={'40px'} onClick={(e) => selectRow()}>
        <Checkbox
          checked={props.item.DSP_FLG === 1}
          onChange={(e) => {
            props.item.DSP_FLG = e.target.checked ? 1 : 0;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
      {/* 表示 線*/}
      <TableCell className={tableStyle.bodyCell} width={'40px'} onClick={(e) => selectRow()}>
        <ColorPicker
          color={props.item.DSP_COLOR}
          setColor={(col) => {
            props.item.DSP_COLOR = col;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
      {/* 計測種別 */}
      <TableCell className={tableStyle.bodyCell} width={'140px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={measFilterCombos()}
          label=""
          value={getKindIndex(props.item, props.kindNoNameSets)}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              var k = props.kindNoNameSets[parseInt(e.target.value)];

              /* 計測種別が空白になった場合チェックを外す */
              /* 計測種別が変更された場合チェックを付ける */
              props.item.SPEED = e.target.value === '0' ? 0 : k.SPEED;
              props.item.KIND_NO = e.target.value === '0' ? 0 : k.NAME_NO;
              props.item.DSP_FLG = e.target.value === '0' ? 0 : 1;
              props.item.DEV_INDEX = e.target.value === '0' ? 0 : props.item.DEV_INDEX;
              props.item.ITM_NAME_NO = 0;
              props.item.TYP_NO = 0;
              props.item.CLC = 0;
              props.item.MCLC_TYP_ID = 0;
              if (k.SPEED === SpeedKind.SPEED_CONAN) {
                //コナンエアの場合SET_NOにKIND_NOを保持
                props.item.SET_NO = k.NAME_NO;
              }

              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* 機器番号・機器名称 */}
      <TableCell className={tableStyle.bodyCell} width={'250px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={props.deviceLists}
          label=""
          value={props.item.DEV_INDEX}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.DEV_INDEX = parseInt(e.target.value);
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* 項目名称 */}
      <TableCell className={tableStyle.bodyCell} width={'140px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={itemListFilterCombos()}
          label=""
          value={props.item.ITM_NAME_NO}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.ITM_NAME_NO = parseInt(e.target.value);
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* データ種別 */}
      <TableCell className={tableStyle.bodyCell} width={'140px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createDataKindCombos()}
          label=""
          value={props.item.CLC}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.CLC = parseInt(e.target.value);
              props.item.MCLC_TYP_ID = 0;
              props.item.TYP_NO = 0;
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* 演算種別 */}
      <TableCell className={tableStyle.bodyCell} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createMclcCombos()}
          label=""
          value={props.item.MCLC_TYP_ID}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.MCLC_TYP_ID = parseInt(e.target.value);
              props.item.TYP_NO = 0;
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* 異常種別 */}
      <TableCell className={tableStyle.bodyCell} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createAlarmKindCombos()}
          label=""
          value={props.item.TYP_NO}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.TYP_NO = parseInt(e.target.value);
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>

      {props.item.SPEED != 1 ? (
        <>
          {/* 軽故障 */}
          <TableCell className={tableStyle.bodyCell} width={'80px'} onClick={(e) => selectRow()}>
            <NumericEntry_inputEx
              className={tableStyle.textField}
              value={props.item.RT_LMT_H}
              fixed={4}
              onChange={(val) => {
                props.item.RT_LMT_H = val;
                props.updateItem(props.item);
              }}
            />
          </TableCell>
          {/* 重故障 */}
          <TableCell className={tableStyle.bodyCell} width={'80px'} onClick={(e) => selectRow()}>
            <NumericEntry_inputEx
              className={tableStyle.textField}
              value={props.item.RT_LMT_HH}
              fixed={4}
              onChange={(val) => {
                props.item.RT_LMT_HH = val;
                props.updateItem(props.item);
              }}
            />
          </TableCell>
        </>
      ) : (
        <>
          {/* 軽故障 */}
          <TableCell className={tableStyle.bodyCell} width={'80px'} onClick={(e) => selectRow()}>
            <NumericEntry_inputEx
              className={tableStyle.textField}
              value={props.item.COL_RT_LMT_H}
              fixed={4}
              onChange={(val) => {
                props.item.COL_RT_LMT_H = val;
                props.updateItem(props.item);
              }}
            />
          </TableCell>
          {/* 重故障 */}
          <TableCell className={tableStyle.bodyCell} width={'80px'} onClick={(e) => selectRow()}>
            <NumericEntry_inputEx
              className={tableStyle.textField}
              value={props.item.COL_RT_LMT_HH}
              fixed={4}
              onChange={(val) => {
                props.item.COL_RT_LMT_HH = val;
                props.updateItem(props.item);
              }}
            />
          </TableCell>
        </>
      )}

      {/* グラフ最小値 */}
      {/* <TableCell className={tableStyle.bodyCell} width={'100px'}>
        <NumericEntry_inputEx
          className={tableStyle.textField}
          value={props.item.GRP_LOW}
          fixed={2}
          onChange={(val) => {
            props.item.GRP_LOW = val;
            props.updateItem(props.item);
          }}
        />
      </TableCell> */}
      {/* グラフ最大値 */}
      {/* <TableCell className={tableStyle.bodyCell} width={'100px'}>
        <NumericEntry_inputEx
          className={tableStyle.textField}
          value={props.item.GRP_HIGH}
          fixed={2}
          onChange={(val) => {
            props.item.GRP_HIGH = val;
            props.updateItem(props.item);
          }}
        />
      </TableCell> */}
      {/* 単位 */}
      <TableCell className={tableStyle.bodyCellCenter} width={'50px'} onClick={(e) => selectRow()}>
        {unit}
      </TableCell>
    </TableRow>
  );
};

export default RealtimeSettingItem;
